<template>
  <v-container fluid justify-center>
    <v-layout row wrap>
      <v-flex xs3 class="subheading">
        <small>Users List</small>
      </v-flex>
      <v-flex xs3></v-flex>
      <v-flex xs4>
        <v-text-field
          v-model="search"
          small
          append-icon="search"
          label="Search"
          class="black--text"
          color="black"
          single-line
          outline
          style="padding: 0px; margin: 0px"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <div class="text-xs-right">
          <IconAdd @clicked="addUser" />
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      row
      v-if="!loadingTable"
      class="justify-center"
      style="padding: 30px"
    >
      <span class="headline grey--text"><strong>Loading Data... </strong></span>
    </v-layout>
    <v-layout
      row
      v-if="!loadingTable"
      class="justify-center"
      style="padding: 10px"
    >
      <Socket class="#36D7B7" style="zoom: 160%"> </Socket>
    </v-layout>
    <v-data-table
      v-if="loadingTable"
      :headers="headers"
      :items="users"
      :search="search"
      select-all
      v-model="selected"
      :pagination.sync="pagination"
      :loading="dataLoading"
    >
      <template slot="items" slot-scope="props">
        <td width="2%">
          <v-checkbox
            v-model="props.selected"
            primary
            hide-details
          ></v-checkbox>
        </td>
        <td width="5%" class="text-xs-left">{{ props.item.id }}</td>
        <td width="12%" class="text-xs-left">
          {{ props.item.first_name }} &nbsp;{{ props.item.last_name }}
        </td>
        <td width="12%" class="text-xs-left">
          {{ props.item.email }}
        </td>
        <td width="10%" class="text-xs-left">
          <span class="userType">
            <strong>
              {{
                props.item.user_type == "S"
                  ? "Support"
                  : props.item.user_type == "P"
                  ? "Production"
                  : "Administrator"
              }}
            </strong>
          </span>
        </td>
        <td width="10%" class="text-xs-left">{{ props.item.mobile }}</td>
        <td width="30%" class="text-xs-left">
          <template v-for="company in props.item.companies">
            <span
              @input="removeCompany(props.item, company)"
              small
              style="zoom: 90%"
              class="companyList mr-1"
              close
            >
              <v-icon
                v-if="props.item.companies.id == company.id"
                small
                class="amber--text"
                >fas fa-check-circle</v-icon
              >
              &nbsp;
              {{ company.name }}
            </span>
          </template>
          <v-icon
            @click="showAccessDialog(props.item)"
            class="black--text"
            small
            >fa fa-plus-circle</v-icon
          >
        </td>
        <td
          width="5%"
          class="text-xs-left"
          :style="
            props.item.active == 1 ? 'font-weight:800' : 'font-weight:400'
          "
        >
          <img
            :src="
              props.item.active == 1
                ? 'images/active.svg'
                : 'images/inactive.svg'
            "
          />
          {{ props.item.active == 1 ? "Active" : "Inactive" }}
        </td>
        <!--   <td  class="text-xs-left">
          <v-chip small color="primary" text-color="white">
            {{ props.item.active == 1 ? "Active" : "Inactive" }}
          </v-chip> 
        </td>-->
        <td width="15%">
          <IconEdit @clicked="editItem(props.item)" />

          &nbsp;
          <!-- <IconCogs @clicked="unlockUser(props.item)" /> -->


          <!-- <v-icon
            @click="unlockUser(props.item)"
            :class="props.item.lock_user == 1 ? 'red--text' : 'green--text'"
            small
          >
            {{ props.item.lock_user == 1 ? "fas fa-lock" : "fas fa-unlock" }}
          </v-icon> -->


          <!-- &nbsp;
          <IconMail
            v-if="!props.item.processing"
            @clicked="sendInvite(props.item)"
          />
          -->
          <v-progress-circular v-if="props.item.processing">
          </v-progress-circular>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <v-dialog v-model="showDialog" max-width="800px">
      <CompanyAccess
        v-if="showCompanyAccess"
        :selectedCompany="selectedCompanyList"
        v-on:closeDialog="closeDialog"
      />
      <UserDialog
        v-if="userEdit"
        :userData="selectedUser"
        v-on:closeDialog="closeUserDialog"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import UserModel from "@/api/service/UserService";
import { RotateSquare2 } from "vue-loading-spinner";
import { Socket } from "vue-loading-spinner";
import CompanyAccess from "./CompanyAccess.vue";
import UserDialog from "./edit.vue";
import IconEdit from "@/components/Icons/IconEdit.vue";
import IconMail from "@/components/Icons/IconMail.vue";
import IconAdd from "@/components/Icons/IconAdd";
//import IconCogs from "@/components/Icons/IconCogs";
import RoleModel from "@/api/service/RolesService";
export default {
  components: {
    RotateSquare2,
    Socket,
    CompanyAccess,
    UserDialog,
    IconEdit,
    IconMail,
    IconAdd,
   // IconCogs
  },
  data() {
    return {
      showDialog: false,
      loadingTable: false,
      userEdit: false,
      showCompanyAccess: false,
      search: "",
      selectedUser: {},
      userTypes: {
        P: "Production",
        S: "Sales",
        A: "Administrator",
      },
      selectedCompanyList: {},
      rowsPerPageItems: ["50", "100", "200", "400", "All"],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: "fat",
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      dataLoading: "indigo",

      selected: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "First Name", value: "first_name" },
        { text: "Email", value: "email" },
        { text: "User Type", value: "user_type" },
        { text: "Mobile", value: "mobile" },
        { text: "Company", value: "companies.name" },
        { text: "Active", value: "iron" },
        {},
      ],
      users: [],
      role: {},
    };
  },
  created: function () {
    this.getRole();
    this.getUser();
  },
  mounted: function () {},
  methods: {
   async getUser(){
    await  UserModel.findAll({})
      .then((response) => {
        this.setUsers(response);
      })
      .catch((error) => {
        console.log(error);
      });
    },
    async getRole() {
      var $data = await RoleModel.getRoleForMyId();
      this.role = $data[0];
      if (this.role.user_type != "A") {
        this.$router.go(-1);
      }
    },
    unlockUser($user) {
      $user.lock_user = $user.lock_user == 1 ? 0 : 1;
      UserModel.update({ id: $user.id, lock_user: $user.lock_user });
    },
    setUsers($user) {
      this.users = $user;
      this.dataLoading = false;
      this.loadingTable = true;
    },
    addUser() {
      //alert("hi")
      this.selectedUser = {};
      this.showDialog = true;
      this.userEdit = true;
    },
    editItem($user) {
      //var $url ='/user/view?id='+id
      //this.$router.push($url)
        this.showCompanyAccess = false;
      this.selectedUser = $user;
      this.showDialog = true;
      this.userEdit = true;
    },
    showAccessDialog($list) {
      this.showDialog = true;
      this.selectedUser = $list;
      this.showCompanyAccess = true;
      this.selectedCompanyList = $list.companyXref;
    },
    removeCompany($user, $company) {
      var $list = JSON.parse($user.company_list);
      var $selectedIndex;
      for (var $i = 0; $i < $list.length; $i++) {
        if ($list[$i].id == $company.id) {
          $selectedIndex = $i;
        }
      }
      $list.splice($selectedIndex, 1);
      $user.company_list = JSON.stringify($list);
      UserModel.update({
        id: $user.id,
        company_list: JSON.stringify($list),
      }).then(($response) => {});
    },
    sendInvite($user) {
      $user.processing = true;
      UserModel.sendInvite($user.id).then(
        ($response) => ($user.processing = false)
      );
    },
    closeUserDialog() {
      this.selectedUser = {};
      //alert("hi")
      this.userEdit = false;
      this.showDialog = false;
        this.getUser();
    },
  async  closeDialog($company)  {
      var $list = [];
      for (var $i = 0; $i < $company.length; $i++) {
        if ($company[$i].access) {
          $list.push($company[$i].team);
        }
      }
    // alert(this.selectedUser[0].id)
    await  UserModel.update({
        id: this.selectedUser.id,
        user_type :this.selectedUser.user_type,
        company_list: $list,
      }).then(($response) => {
        this.selectedUser.company_list = JSON.stringify($list);
      });
     
      this.showDialog = false;
      this.showCompanyAccess = false;
      this.getUser();
    },
  },
};
</script>
<style >
.userType {
  background: #ffe9c4;
  padding: 1px;
  border-radius: 10px;
  color: #ffa000;
  padding: 5px;
}

.companyList {
  background: #eddfff;
  padding: 1px;
  border-radius: 10px;
  color: #7200ff;
  padding: 5px;
}
</style>